import { createPortal } from 'react-dom';
import { useRef, useState, useEffect } from 'react';
import { Spin, Progress, theme } from 'antd';
import { loadingEmitter } from '@/utils/loadingEmitter';

export const showLoading = loadingEmitter.show;
export const hideLoading = loadingEmitter.hide;
export const updateLoadingProgress = loadingEmitter.updateProgress;

export const LoadingWrap = () => {
  const [state, setState] = useState({ count: 0, progress: null as number | null });
  const { token } = theme.useToken();
  const containerRef = useRef<HTMLElement | null>(null);

  useEffect(() => loadingEmitter.subscribe(setState), []);

  if (!containerRef.current) {
    containerRef.current = document.getElementById('loading-portal');
  }

  return createPortal(state.count > 0 ?
    <div style={{ position: 'fixed', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: 'rgba(0, 0, 0, 0.3)', zIndex: 99999 }}>
      {state.progress !== null ? <Progress type="circle" percent={state.progress} strokeColor={token.colorPrimary} format={(percent) => <span style={{ color: token.colorPrimary }}>{percent}%</span>} /> : <Spin size="large" />}
    </div> : null, containerRef.current!);
};